/* eslint-disable @typescript-eslint/no-restricted-imports */
import * as proceduralTexture from "procedural-textures/legacy/legacy-road";
export { proceduralTexture };
export default proceduralTexture;
